import state from './moduleQueueState'
import mutations from './moduleQueueMutations'
import actions from './moduleQueueActions'
import getters from './moduleQueueGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
